export default __webpack_public_path__ + "static/wantaw-resto-0009421df64cfd101b57e3cfec7be2c8.pdf";